import { createSlice }            from '@reduxjs/toolkit';
import * as eventCategoryReducers from 'Redux/Reducers/EventCategory';
import { EventCategory }          from 'Domain/Models';

export interface IEventCategoryState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, EventCategory>,
  lastUpdateId: string | null,
  maxCount: number,
}

export const eventCategorySlice = createSlice({
  name: 'eventCategory',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
  },
  reducers: eventCategoryReducers,
});
